import { ReactNode, useCallback, useEffect, useMemo } from 'react';
import { useSet } from '@/shared/lib/hooks/useSet';
import { useMobileDetect } from '@/shared/lib/hooks/useMobileDetect';
import { FloatingContext } from './floatingContext';

interface FloatingProviderProps {
  children?: ReactNode;
}

const SCROLLBAR_WIDTH = 0;
const PADDING_PROPERTY = 'padding-right';

export const FloatingProvider = ({ children }: FloatingProviderProps) => {
  const elementsSet = useSet<string>([]);
  const { isDesktop } = useMobileDetect();

  useEffect(() => {
    if (elementsSet.size > 0) {
      document.body.style.setProperty('overflow', 'hidden');
      if (isDesktop()) {
        document.body.style.setProperty(PADDING_PROPERTY, `${SCROLLBAR_WIDTH}px`);
      }
    } else {
      document.body.style.removeProperty('overflow');
      if (isDesktop()) {
        document.body.style.removeProperty(PADDING_PROPERTY);
      }
    }
  }, [elementsSet.size, isDesktop]);

  const appendElement = useCallback(
    (elementId: string) => {
      elementsSet.add(elementId);
    },
    [elementsSet],
  );

  const removeElement = useCallback(
    (elementId: string) => {
      elementsSet.delete(elementId);
    },
    [elementsSet],
  );

  const providedValue = useMemo(
    () => ({
      appendElement,
      removeElement,
    }),
    [appendElement, removeElement],
  );
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <FloatingContext.Provider value={providedValue}>{children}</FloatingContext.Provider>
  );
};
